export abstract class Modal {
    constructor() {}
}
